module.exports = __webpack_public_path__ + "static/media/legallyblind.2eb9c538.gif";